// src/constants/patientBoxes.js
//
// The Coordinator (CRC) page's patient boxes. A patient's box is their stored
// `status` string. Shared so the CRC page and "Add to RegX" (weekly report)
// offer exactly the same boxes. Values moved here unchanged from
// CoordinatorPage.js (2026-10-09).

export const CRC_BOX_STATUSES = [
  "Lung Center Referrals",
  "Awaiting PI Review",
  "Pending Medical Records", // added 2026-10-15
  "Rescreen",
  "Deceased",
  "Provider to Screen",
  "Provider to Schedule",
  "Unable to Reach",
  "Ready to Schedule", // added 2026-10-26 (yellow dot)
  "Patient Scheduled for Screen",
  "Screen Failed",
  "Enrolled",
  "Not Interested",
];

// Per-coordinator boxes, stored as `${stage} (${coordinator name})`.
export const COORDINATOR_BOX_STAGES = ["Pending", "Coordinator to Screen", "Schedule with Coordinator"];

export const coordinatorBoxStatus = (stage, name) => `${stage} (${name})`;

// Not a box: the status of a patient in Potential Duplicates. RegX patients
// there live in `duplicates`; a Google Sheet patient (Dubois) only carries the
// status, and the CRC page, weekly-report search and Scan for Duplicates treat
// that row as a duplicate too (2026-10-29).
export const POTENTIAL_DUPLICATE_STATUS = "Potential Duplicate";
export const isPotentialDuplicateStatus = (status) =>
  String(status || "").trim().toLowerCase() === POTENTIAL_DUPLICATE_STATUS.toLowerCase();
